import { ReactElement, ReactNode } from 'react';

import { IconPropType, Icon } from '@/ui/Icon';
import { RootStyled } from '@/ui/Banner/styles';
import { IconButton } from '@/ui/Button';

type BannerVariant = 'light' | 'dark';

type BannerProps = {
  variant?: BannerVariant;
  withRoundedBorder?: boolean;
  icon?: IconPropType;
  actions?: ReactNode;
  label?: string;
  onCloseClick?: VoidFunction;
  className?: string;
};

export const Banner = ({
  variant = 'dark',
  actions,
  withRoundedBorder,
  icon,
  label,
  onCloseClick,
  className,
}: BannerProps): ReactElement => {
  return (
    <RootStyled variant={variant} withRoundedBorder={withRoundedBorder} className={className}>
      {!!icon && <Icon icon={icon} />}
      {label}
      {actions}
      {!!onCloseClick && <IconButton icon="xmark" onClick={onCloseClick} buttonVariant="ghost" />}
    </RootStyled>
  );
};
